"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSubscriptionsControllerGetMyFeaturesV1200Response = instanceOfSubscriptionsControllerGetMyFeaturesV1200Response;
exports.SubscriptionsControllerGetMyFeaturesV1200ResponseFromJSON = SubscriptionsControllerGetMyFeaturesV1200ResponseFromJSON;
exports.SubscriptionsControllerGetMyFeaturesV1200ResponseFromJSONTyped = SubscriptionsControllerGetMyFeaturesV1200ResponseFromJSONTyped;
exports.SubscriptionsControllerGetMyFeaturesV1200ResponseToJSON = SubscriptionsControllerGetMyFeaturesV1200ResponseToJSON;
exports.SubscriptionsControllerGetMyFeaturesV1200ResponseToJSONTyped = SubscriptionsControllerGetMyFeaturesV1200ResponseToJSONTyped;
var MyFeaturesResponseDto_1 = require("./MyFeaturesResponseDto");
/**
 * Check if a given object implements the SubscriptionsControllerGetMyFeaturesV1200Response interface.
 */
function instanceOfSubscriptionsControllerGetMyFeaturesV1200Response(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function SubscriptionsControllerGetMyFeaturesV1200ResponseFromJSON(json) {
    return SubscriptionsControllerGetMyFeaturesV1200ResponseFromJSONTyped(json, false);
}
function SubscriptionsControllerGetMyFeaturesV1200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'status': json['status'],
        'message': json['message'],
        'data': json['data'] == null ? undefined : (0, MyFeaturesResponseDto_1.MyFeaturesResponseDtoFromJSON)(json['data']),
        'error': json['error'] == null ? undefined : json['error'],
        'errorCode': json['errorCode'] == null ? undefined : json['errorCode'],
        'meta': json['meta'] == null ? undefined : json['meta'],
        'traceId': json['traceId'] == null ? undefined : json['traceId'],
    };
}
function SubscriptionsControllerGetMyFeaturesV1200ResponseToJSON(json) {
    return SubscriptionsControllerGetMyFeaturesV1200ResponseToJSONTyped(json, false);
}
function SubscriptionsControllerGetMyFeaturesV1200ResponseToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'statusCode': value['statusCode'],
        'status': value['status'],
        'message': value['message'],
        'data': (0, MyFeaturesResponseDto_1.MyFeaturesResponseDtoToJSON)(value['data']),
        'error': value['error'],
        'errorCode': value['errorCode'],
        'meta': value['meta'],
        'traceId': value['traceId'],
    };
}
